module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-23-54c901ae893520f89d6415dcaa3a696d.jpg";